import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "../components/Sidebar";

function Privacy() {
  return (
    <Container className="py-4">
      <Row className="g-4">
        <Col lg={8}>
          <h2 className="block-title">Privacy Policy</h2>
          <article className="article">
            <div className="article-inner">
              <p>
                At APK Downloads (apkdownloads.net), the privacy of our visitors is
                important to us. This privacy policy explains what personal
                information we collect and how we use it.
              </p>

              <h2>Information Collection</h2>
              <p>
                We may request personally identifiable information that can be used
                to contact or identify you, including your name, email address,
                address and phone number.
              </p>

              <h2>Log Data</h2>
              <p>
                Like many site operators, we collect information that your browser
                sends whenever you visit our Site. This Log Data may include
                information such as your computer's IP address, browser type,
                browser version, the pages of our Site that you visit, and the time
                and date of your visit.
              </p>

              <h2>Cookies</h2>
              <p>
                Cookies are files with a small amount of data that are stored on
                your computer. We use cookies to collect information. You can
                instruct your browser to refuse all cookies, but if you do not
                accept cookies you may not be able to use some portions of our Site.
              </p>

              <h2>Security</h2>
              <p>
                The security of your personal information is important to us, but
                remember that no method of transmission over the Internet, or method
                of electronic storage, is 100% secure. While we strive to use
                acceptable means to protect your personal information, we cannot
                guarantee its absolute security.
              </p>

              <h2>Third-Party Links</h2>
              <p>
                Our Site may contain links to external websites. APK Downloads
                assumes no responsibility for the content or privacy practices of
                those third-party sites.
              </p>

              <h2>Changes To This Privacy Policy</h2>
              <p>
                We may update our privacy policy from time to time. We will post any
                changes on this page.
              </p>

              <div className="info-box">
                If you have any questions about this privacy policy, please contact
                us at <a href="mailto:vootapks@gmail.com">vootapks@gmail.com</a>.
              </div>
            </div>
          </article>
        </Col>
        <Col lg={4}><Sidebar /></Col>
      </Row>
    </Container>
  );
}

export default Privacy;
